import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";
import { getBackendAssetsUrl } from "./../../config/Production";
import {
  ValidateOnlyMainCategoryFunc,
  GetRelatedSubCategoryAgainstMainCategory,
} from "./../../api/index";
import CategorySlider from "../../components/Sliders/CategorySlider";
import LoaderComponent from "../../components/Loader/LoaderComponent";

function MainCategory() {
  const { maincategory } = useParams();
  const [loading, setLoading] = useState(false);
  const [backurl, setBackUrl] = useState("");
  const [foldername, setFolderName] = useState("");
  const [mainCategory, setMainCategory] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [categoryUrl, setCategoryUrl] = useState("");
  const [relatedSubCategories, setRelatedSubCategories] = useState([]);
  const [categoryImages, setCategoryImages] = useState([]);

  const categorySliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await ValidateOnlyMainCategoryFunc({
          mainCategory: maincategory,
        });
        const data = res.data.data;

        if (data.CategoryExist == "yes") {
          setMainCategory(data.CategoryData);
          setCategoryImages(data.CategoryData.category_images.split("|") || []);
          setFolderName(
            data.CategoryData.category_name.replaceAll(" ", "_").toLowerCase(),
          );
          const response = await GetRelatedSubCategoryAgainstMainCategory({
            mainCategory: maincategory,
          });

          setRelatedSubCategories(
            response.data.data.RelatedSubCategoryData.get_sub_categories || [],
          );
        } else {
        }
      } catch (error) {
        console.error("Main category fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    setBackUrl(getBackendAssetsUrl());
    fetchData();
  }, [maincategory]);

  return (
    <section className="category-detail-section clearfix">
      {loading == true ? (
        <LoaderComponent />
      ) : (
        <div className="container">
          {/* ================= CATEGORY DETAILS ================= */}
          <div className="row mb-60">
            {/* ================= MAIN CATEGORY IMAGE SLIDER ================= */}
            <div className="col-lg-6">
              <Slider {...categorySliderSettings}>
                {categoryImages.map((img, index) => (
                  <div key={index} className="category-slider-item">
                    <img
                      src={`${backurl}shop_main_category/${foldername}/${img}_large.webp`}
                      alt={mainCategory?.category_name}
                      className="img-fluid border-rad_20 w-100"
                    />
                  </div>
                ))}
              </Slider>
            </div>

            <div className="col-lg-6 text-center">
              <h2 className="mb-15">{mainCategory.category_name}</h2>
              <div
                className="category-description mx-auto"
                style={{ maxWidth: "900px" }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    mainCategory.short_description || "",
                  ),
                }}
              ></div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 col-12">
              <h4>Category Description</h4>
              <div
                className="category-description"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    mainCategory.long_description || "",
                  ),
                }}
              ></div>
            </div>
            <div className="col-lg-12 col-12">
              <h4>Category specifications</h4>
              <div
                className="category-description"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(mainCategory.specifications || ""),
                }}
              ></div>
            </div>
          </div>

          {/* ================= SUB CATEGORY SLIDER ================= */}
          <CategorySlider
            categoryName={categoryName}
            categoryUrl={categoryUrl}
            relatedSubCategories={relatedSubCategories}
            backurl={backurl}
          />
        </div>
      )}
    </section>
  );
}

export default MainCategory;
